import request from "@/utils/request";

// 主页--房间类型下拉框
export const listPageRoomClass = (params) => {
  return request({
    url: "/business/cashierShift/listPageRoomClass",
    method: "GET",
    params,
  });
};

// 主页--房间子类型下拉框
export const listPageRoomType = (params) => {
  return request({
    url: "/business/cashierShift/listPageRoomType",
    method: "GET",
    params,
  });
};

// 主页--房间子类型下拉框
export const listPageSeatNums = (params) => {
  return request({
    url: "/business/cashierShift/listPageSeatNums",
    method: "GET",
    params,
  });
};

// 根据字典类型查询字典数据信息
export const selectDictType = (data) => {
  return request({
    url: "/system/dict/data/selectDictType",
    method: "POST",
    data,
  });
};

// 主页--房间子类型下拉框
export const listItemRoom = (params) => {
  return request({
    url: "/artificer/room/listItemRoom",
    method: "GET",
    params,
  });
};

/**
 * 技师班次
 * @param {*} params
 * @returns
 */
export const artificerListIdNames = (params) => {
  return request({
    url: "/artificer/artificerClasses/listIdNames",
    method: "GET",
    params,
  });
};

/**
 * 技师类型
 * @param {*} params
 * @returns
 */
export const artificerTypeListIdNames = (params) => {
  return request({
    url: "/artificer/artificerType/list/idName",
    method: "GET",
    params,
  });
};

// 获取所有排钟技师
export const allList = (data) => {
  return request({
    url: "/artificer/chimes/allList",
    method: "POST",
    data,
  });
};

// 提交主页技师查询条件设置
export const submitArtificerReqSettings = (data) => {
  return request({
    url: "/select/artificer/submitArtificerReqSettings",
    method: "POST",
    data,
  });
};

// 获取主页技师查询条件设置
export const selectArtificerReqSettings = (params) => {
  return request({
    url: "/select/artificer/selectArtificerReqSettings",
    method: "GET",
    params,
  });
};

// 上钟
export const goClock = (data) => {
  return request({
    url: "/artificer/management/goClock",
    method: "POST",
    data,
  });
};

// 上钟
export const downClock = (data) => {
  return request({
    url: "/artificer/management/downClock",
    method: "POST",
    data,
  });
};

// 恢复上钟
export const restoreGoClock = (data) => {
  return request({
    url: "/artificer/management/restoreGoClock",
    method: "POST",
    data,
  });
};

// 下钟
export const downClocks = (data) => {
  return request({
    url: "/artificer/management/downClock",
    method: "POST",
    data,
  });
};

// 调头牌
export const transferHead = (data) => {
  return request({
    url: "/artificer/management/transferHead",
    method: "POST",
    data,
  });
};

// 调尾牌
export const transferTail = (data) => {
  return request({
    url: "/artificer/management/transferTail",
    method: "POST",
    data,
  });
};

// 调牌
export const transferAfterUser = (data) => {
  return request({
    url: "/artificer/management/transferAfterUser",
    method: "POST",
    data,
  });
};

// 修改技师状态
export const updateArtificerStatus = (data) => {
  return request({
    url: "/artificer/management/updateArtificerStatus",
    method: "POST",
    data,
  });
};

// 修改技师状态
export const transferBeforeUser = (data) => {
  return request({
    url: "/artificer/management/transferBeforeUser",
    method: "POST",
    data,
  });
};

// 技师详情
export const artificerInfo = (params) => {
  return request({
    url: "/select/artificer/info",
    method: "GET",
    params,
  });
};

// 技师解锁
export const unlockArtificer = (data) => {
  return request({
    url: "/artificer/management/unlockArtificer",
    method: "POST",
    data,
  });
};

// 获取技师分类名称
export const userListTypeName = (params) => {
  return request({
    url: "/moreBell/moreBellConfig/listTypeName",
    method: "get",
    params,
  });
};

// 查询userStatusColor列表
export const selUserStatusColor = (params) => {
  return request({
    url: "/user/userStatusColor/list",
    method: "GET",
    params,
  })
}

// 获取营业时间
export const getBusinessTime = (params) => {
  return request({
    url: "/collect/collectRecord/getBusinessTime",
    method: "GET",
    params,
  })
}

// 获取营业时间
export const getConfig = (params) => {
  return request({
    url: "/organ/config",
    method: "get",
    params,
  })
}

// 获取营业时间
export const updateConfig = (data) => {
  return request({
    url: "/organ/config",
    method: "put",
    data,
  })
}
